import { getWebsiteSlug } from "@/lib/websiteScope";

export const PUBLIC_API_BASE_URL = (
  import.meta.env.VITE_API_ENDPOINT ||
  import.meta.env.VITE_API_URL ||
  "https://admin.coretechs.se/website"
).replace(/\/$/, "");

export const PUBLIC_WEBSITE_SLUG = getWebsiteSlug();

export const buildApiHeaders = (): Record<string, string> => ({
  "Content-Type": "application/json",
});

export const makePublicRequest = async (
  endpoint: string,
  options: RequestInit = {},
): Promise<Response> => {
  const url = endpoint.startsWith("http")
    ? endpoint
    : `${PUBLIC_API_BASE_URL}${endpoint.startsWith("/") ? "" : "/"}${endpoint}`;

  const response = await fetch(url, {
    ...options,
    headers: { ...buildApiHeaders(), ...options.headers },
  });

  if (!response.ok) {
    throw new Error(`API request failed with status ${response.status}`);
  }
  return response;
};

export const postPublicEvent = (endpoint: string, body: unknown): void => {
  void makePublicRequest(endpoint, {
    method: "POST",
    body: JSON.stringify(body),
  }).catch(() => {});
};
